export const required = 'This field is required.';

export const minLength = 'The text is too short.';

export const maxLength = 'The text is too long.';

export const FORM_ERROR = '@form_error' as const;

export const FIELD_ERROR = '@api' as const;
